import CTAButton from "components/CTAButton";
import Modal from "features/Modal/Modal";
import { ModalBody, ModalButtonWrapper } from "features/Modal/styled";
import React from "react";

function CheckEmailModal({
  closeModal,
  email,
}: {
  closeModal: () => void;
  email: string;
}) {
  return (
    <Modal title="Check your email" closeModal={closeModal}>
      <ModalBody>
        <p>
          We've sent an email to&nbsp;
          <strong>{email}</strong>.<br />
          It will expire shortly, so please verify it right now.
        </p>
      </ModalBody>
      <ModalButtonWrapper>
        <CTAButton onClick={closeModal}>OK</CTAButton>
      </ModalButtonWrapper>
    </Modal>
  );
}

export default CheckEmailModal;
